/* src/components/RateFinder/RateFinder.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	add_render_callback,
	append_hydration,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	component_subscribe,
	create_bidirectional_transition,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert_hydration,
	listen,
	mount_component,
	safe_not_equal,
	set_data,
	space,
	src_url_equal,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

import {
	customerType,
	preselectedPlan,
	showSuccessScreen,
	stateLog,
	userStep,
	loading
} from './stores';

import { states } from './consts';
import { fade } from 'svelte/transition';
import ZipLookup from './ZipLookup.svelte';
import UtilitySelect from './UtilitySelect.svelte';
import Rates from './Rates.svelte';
import PowerKioskContract from './PowerKioskContract.svelte';
import Confirmation from './Confirmation.svelte';
import LoadingAnimation from '../LoadingAnimation/LoadingAnimation.svelte';
import sendEvent from '../../helpers/svelte/sendEvent';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[12] = list[i];
	child_ctx[14] = i;
	return child_ctx;
}

// (56:0) {#if $showSuccessScreen}
function create_if_block_6(ctx) {
	let confirmation;
	let current;
	confirmation = new Confirmation({});

	return {
		c() {
			create_component(confirmation.$$.fragment);
		},
		l(nodes) {
			claim_component(confirmation.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(confirmation, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(confirmation.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(confirmation.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(confirmation, detaching);
		}
	};
}

// (59:0) {#if $userStep !== 4}
function create_if_block_1(ctx) {
	let h1;
	let t0;
	let t1;
	let p;
	let t2;
	let t3;
	let div2;
	let div0;
	let ziplookup;
	let t4;
	let utilityselect;
	let t5;
	let t6;
	let powerkioskcontract;
	let t7;
	let aside;
	let div1;
	let h2;
	let t8;
	let t9;
	let ul;
	let current;

	ziplookup = new ZipLookup({
			props: {
				pkServiceTypes: /*data*/ ctx[0].pkServiceTypes
			}
		});

	utilityselect = new UtilitySelect({});
	let if_block = /*$customerType*/ ctx[3] !== 'Large Business' && create_if_block_5(ctx);
	powerkioskcontract = new PowerKioskContract({});
	let each_value = /*steps*/ ctx[4];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			h1 = element("h1");
			t0 = text("Switching Electricity or Natural Gas Providers is Easy");
			t1 = space();
			p = element("p");
			t2 = text("Start by selecting your service type and ZIP code in the form below.");
			t3 = space();
			div2 = element("div");
			div0 = element("div");
			create_component(ziplookup.$$.fragment);
			t4 = space();
			create_component(utilityselect.$$.fragment);
			t5 = space();
			if (if_block) if_block.c();
			t6 = space();
			create_component(powerkioskcontract.$$.fragment);
			t7 = space();
			aside = element("aside");
			div1 = element("div");
			h2 = element("h2");
			t8 = text("Follow these simple steps");
			t9 = space();
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			this.h();
		},
		l(nodes) {
			h1 = claim_element(nodes, "H1", { class: true });
			var h1_nodes = children(h1);
			t0 = claim_text(h1_nodes, "Switching Electricity or Natural Gas Providers is Easy");
			h1_nodes.forEach(detach);
			t1 = claim_space(nodes);
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			t2 = claim_text(p_nodes, "Start by selecting your service type and ZIP code in the form below.");
			p_nodes.forEach(detach);
			t3 = claim_space(nodes);
			div2 = claim_element(nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			div0 = claim_element(div2_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			claim_component(ziplookup.$$.fragment, div0_nodes);
			t4 = claim_space(div0_nodes);
			claim_component(utilityselect.$$.fragment, div0_nodes);
			t5 = claim_space(div0_nodes);
			if (if_block) if_block.l(div0_nodes);
			t6 = claim_space(div0_nodes);
			claim_component(powerkioskcontract.$$.fragment, div0_nodes);
			div0_nodes.forEach(detach);
			t7 = claim_space(div2_nodes);
			aside = claim_element(div2_nodes, "ASIDE", { class: true });
			var aside_nodes = children(aside);
			div1 = claim_element(aside_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			h2 = claim_element(div1_nodes, "H2", { class: true });
			var h2_nodes = children(h2);
			t8 = claim_text(h2_nodes, "Follow these simple steps");
			h2_nodes.forEach(detach);
			t9 = claim_space(div1_nodes);
			ul = claim_element(div1_nodes, "UL", { class: true });
			var ul_nodes = children(ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(ul_nodes);
			}

			ul_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			aside_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h1, "class", "svelte-cyqq6g");
			attr(p, "class", "subheading svelte-cyqq6g");
			attr(div0, "class", "white-page svelte-cyqq6g");
			attr(h2, "class", "svelte-cyqq6g");
			attr(ul, "class", "svelte-cyqq6g");
			attr(div1, "class", "aside-content svelte-cyqq6g");
			attr(aside, "class", "svelte-cyqq6g");
			attr(div2, "class", "wrapper svelte-cyqq6g");
		},
		m(target, anchor) {
			insert_hydration(target, h1, anchor);
			append_hydration(h1, t0);
			insert_hydration(target, t1, anchor);
			insert_hydration(target, p, anchor);
			append_hydration(p, t2);
			insert_hydration(target, t3, anchor);
			insert_hydration(target, div2, anchor);
			append_hydration(div2, div0);
			mount_component(ziplookup, div0, null);
			append_hydration(div0, t4);
			mount_component(utilityselect, div0, null);
			append_hydration(div0, t5);
			if (if_block) if_block.m(div0, null);
			append_hydration(div0, t6);
			mount_component(powerkioskcontract, div0, null);
			append_hydration(div2, t7);
			append_hydration(div2, aside);
			append_hydration(aside, div1);
			append_hydration(div1, h2);
			append_hydration(h2, t8);
			append_hydration(div1, t9);
			append_hydration(div1, ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			const ziplookup_changes = {};
			if (dirty & /*data*/ 1) ziplookup_changes.pkServiceTypes = /*data*/ ctx[0].pkServiceTypes;
			ziplookup.$set(ziplookup_changes);

			if (/*$customerType*/ ctx[3] !== 'Large Business') {
				if (if_block) {
					if (dirty & /*$customerType*/ 8) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_5(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(div0, t6);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			if (dirty & /*$userStep, handleAsideClick, steps, $loading*/ 210) {
				each_value = /*steps*/ ctx[4];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(ul, null);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(ziplookup.$$.fragment, local);
			transition_in(utilityselect.$$.fragment, local);
			transition_in(if_block);
			transition_in(powerkioskcontract.$$.fragment, local);

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			transition_out(ziplookup.$$.fragment, local);
			transition_out(utilityselect.$$.fragment, local);
			transition_out(if_block);
			transition_out(powerkioskcontract.$$.fragment, local);
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(h1);
			if (detaching) detach(t1);
			if (detaching) detach(p);
			if (detaching) detach(t3);
			if (detaching) detach(div2);
			destroy_component(ziplookup);
			destroy_component(utilityselect);
			if (if_block) if_block.d();
			destroy_component(powerkioskcontract);
			destroy_each(each_blocks, detaching);
		}
	};
}

// (67:6) {#if $customerType !== 'Large Business'}
function create_if_block_5(ctx) {
	let rates;
	let current;
	rates = new Rates({});

	return {
		c() {
			create_component(rates.$$.fragment);
		},
		l(nodes) {
			claim_component(rates.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(rates, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(rates.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(rates.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(rates, detaching);
		}
	};
}

// (78:12) {#if step}
function create_if_block_2(ctx) {
	let li;
	let t0;
	let a;
	let t1;
	let t2_value = /*step*/ ctx[12] + "";
	let t2;
	let a_href_value;
	let t3;
	let current;
	let mounted;
	let dispose;
	let if_block0 = /*$loading*/ ctx[6] && /*$userStep*/ ctx[1] === /*i*/ ctx[14] && create_if_block_4(ctx);
	let if_block1 = /*$userStep*/ ctx[1] >= /*i*/ ctx[14] + 1 && create_if_block_3(ctx);

	function click_handler() {
		return /*click_handler*/ ctx[9](/*i*/ ctx[14]);
	}

	return {
		c() {
			li = element("li");
			if (if_block0) if_block0.c();
			t0 = space();
			a = element("a");
			if (if_block1) if_block1.c();
			t1 = space();
			t2 = text(t2_value);
			t3 = space();
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			if (if_block0) if_block0.l(li_nodes);
			t0 = claim_space(li_nodes);
			a = claim_element(li_nodes, "A", { href: true, class: true });
			var a_nodes = children(a);
			if (if_block1) if_block1.l(a_nodes);
			t1 = claim_space(a_nodes);
			t2 = claim_text(a_nodes, t2_value);
			a_nodes.forEach(detach);
			t3 = claim_space(li_nodes);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(a, "href", a_href_value = "#step-" + (/*i*/ ctx[14] + 1) + "-heading");
			attr(a, "class", "svelte-cyqq6g");
			attr(li, "class", "svelte-cyqq6g");
			toggle_class(li, "active", /*$userStep*/ ctx[1] === /*i*/ ctx[14]);
		},
		m(target, anchor) {
			insert_hydration(target, li, anchor);
			if (if_block0) if_block0.m(li, null);
			append_hydration(li, t0);
			append_hydration(li, a);
			if (if_block1) if_block1.m(a, null);
			append_hydration(a, t1);
			append_hydration(a, t2);
			append_hydration(li, t3);
			current = true;

			if (!mounted) {
				dispose = listen(li, "click", click_handler);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (/*$loading*/ ctx[6] && /*$userStep*/ ctx[1] === /*i*/ ctx[14]) {
				if (if_block0) {
					if (dirty & /*$loading, $userStep*/ 66) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_4(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(li, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*$userStep*/ ctx[1] >= /*i*/ ctx[14] + 1) {
				if (if_block1) {
					
				} else {
					if_block1 = create_if_block_3(ctx);
					if_block1.c();
					if_block1.m(a, t1);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if ((!current || dirty & /*steps*/ 16) && t2_value !== (t2_value = /*step*/ ctx[12] + "")) set_data(t2, t2_value);

			if (dirty & /*$userStep*/ 2) {
				toggle_class(li, "active", /*$userStep*/ ctx[1] === /*i*/ ctx[14]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(li);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			mounted = false;
			dispose();
		}
	};
}

// (80:16) {#if $loading && $userStep === i}
function create_if_block_4(ctx) {
	let loadinganimation;
	let current;
	loadinganimation = new LoadingAnimation({});

	return {
		c() {
			create_component(loadinganimation.$$.fragment);
		},
		l(nodes) {
			claim_component(loadinganimation.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(loadinganimation, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(loadinganimation.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(loadinganimation.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(loadinganimation, detaching);
		}
	};
}

// (84:18) {#if $userStep >= i + 1}
function create_if_block_3(ctx) {
	let img;
	let img_src_value;

	return {
		c() {
			img = element("img");
			this.h();
		},
		l(nodes) {
			img = claim_element(nodes, "IMG", { src: true, alt: true, class: true });
			this.h();
		},
		h() {
			if (!src_url_equal(img.src, img_src_value = "/site-images/check-circle-blue.svg")) attr(img, "src", img_src_value);
			attr(img, "alt", "checkmark");
			attr(img, "class", "svelte-cyqq6g");
		},
		m(target, anchor) {
			insert_hydration(target, img, anchor);
		},
		d(detaching) {
			if (detaching) detach(img);
		}
	};
}

// (77:10) {#each steps as step, i}
function create_each_block(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*step*/ ctx[12] && create_if_block_2(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*step*/ ctx[12]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*steps*/ 16) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_2(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (98:0) {#if $preselectedPlan && $userStep < 1}
function create_if_block(ctx) {
	let div;
	let loadinganimation;
	let t0;
	let p;
	let t1;
	let div_transition;
	let current;
	loadinganimation = new LoadingAnimation({ props: { color: "white", size: "20px" } });

	return {
		c() {
			div = element("div");
			create_component(loadinganimation.$$.fragment);
			t0 = space();
			p = element("p");
			t1 = text("Please wait while we look for plans...");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(loadinganimation.$$.fragment, div_nodes);
			t0 = claim_space(div_nodes);
			p = claim_element(div_nodes, "P", { class: true });
			var p_nodes = children(p);
			t1 = claim_text(p_nodes, "Please wait while we look for plans...");
			p_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p, "class", "svelte-cyqq6g");
			attr(div, "class", "big-loader svelte-cyqq6g");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			mount_component(loadinganimation, div, null);
			append_hydration(div, t0);
			append_hydration(div, p);
			append_hydration(p, t1);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(loadinganimation.$$.fragment, local);

			add_render_callback(() => {
				if (!div_transition) div_transition = create_bidirectional_transition(div, fade, {}, true);
				div_transition.run(1);
			});

			current = true;
		},
		o(local) {
			transition_out(loadinganimation.$$.fragment, local);
			if (!div_transition) div_transition = create_bidirectional_transition(div, fade, {}, false);
			div_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(loadinganimation);
			if (detaching && div_transition) div_transition.end();
		}
	};
}

function create_fragment(ctx) {
	let t0;
	let t1;
	let if_block2_anchor;
	let current;
	let if_block0 = /*$showSuccessScreen*/ ctx[5] && create_if_block_6(ctx);
	let if_block1 = /*$userStep*/ ctx[1] !== 4 && create_if_block_1(ctx);
	let if_block2 = /*$preselectedPlan*/ ctx[2] && /*$userStep*/ ctx[1] < 1 && create_if_block(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t0 = space();
			if (if_block1) if_block1.c();
			t1 = space();
			if (if_block2) if_block2.c();
			if_block2_anchor = empty();
		},
		l(nodes) {
			if (if_block0) if_block0.l(nodes);
			t0 = claim_space(nodes);
			if (if_block1) if_block1.l(nodes);
			t1 = claim_space(nodes);
			if (if_block2) if_block2.l(nodes);
			if_block2_anchor = empty();
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert_hydration(target, t0, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert_hydration(target, t1, anchor);
			if (if_block2) if_block2.m(target, anchor);
			insert_hydration(target, if_block2_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*$showSuccessScreen*/ ctx[5]) {
				if (if_block0) {
					if (dirty & /*$showSuccessScreen*/ 32) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_6(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*$userStep*/ ctx[1] !== 4) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*$userStep*/ 2) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(t1.parentNode, t1);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (/*$preselectedPlan*/ ctx[2] && /*$userStep*/ ctx[1] < 1) {
				if (if_block2) {
					if (dirty & /*$preselectedPlan, $userStep*/ 6) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t0);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(t1);
			if (if_block2) if_block2.d(detaching);
			if (detaching) detach(if_block2_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $userStep;
	let $preselectedPlan;
	let $customerType;
	let $stateLog;
	let $showSuccessScreen;
	let $loading;
	component_subscribe($$self, userStep, $$value => $$invalidate(1, $userStep = $$value));
	component_subscribe($$self, preselectedPlan, $$value => $$invalidate(2, $preselectedPlan = $$value));
	component_subscribe($$self, customerType, $$value => $$invalidate(3, $customerType = $$value));
	component_subscribe($$self, stateLog, $$value => $$invalidate(8, $stateLog = $$value));
	component_subscribe($$self, showSuccessScreen, $$value => $$invalidate(5, $showSuccessScreen = $$value));
	component_subscribe($$self, loading, $$value => $$invalidate(6, $loading = $$value));
	let { data } = $$props;
	const isBrowser = process.env.componentType === 'browser';
	const isDev = isBrowser && window && window.location.hostname.includes('localhost');

	let steps = [
		'Step 1 — Select your service',
		'Step 2 — Choose your utility',
		'Step 3 — Select a plan',
		'Step 4 — Submit your form'
	];

	const handleAsideClick = step => {
		sendEvent({
			category: 'buyflow',
			action: 'aside-step-click',
			label: `Step ${step} clicked`
		});
	};

	const click_handler = i => handleAsideClick(i + 1);

	$$self.$$set = $$props => {
		if ('data' in $$props) $$invalidate(0, data = $$props.data);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$stateLog*/ 256) {
			$: if (isDev) console.log('Log state:', $stateLog);
		}

		if ($$self.$$.dirty & /*$customerType*/ 8) {
			$: if ($customerType === 'Large Business') {
				$$invalidate(4, steps = [
					'Step 1 — Select your service',
					'Step 2 — Choose your utility',
					'',
					'Step 3 — Request a quote'
				]);
			} else {
				$$invalidate(4, steps = [
					'Step 1 — Select your service',
					'Step 2 — Choose your utility',
					'Step 3 — Select a plan',
					'Step 4 — Submit your form'
				]);
			}
		}

		if ($$self.$$.dirty & /*$preselectedPlan, $userStep*/ 6) {
			$: {
				if ($preselectedPlan && $userStep < 1 && isBrowser && window) {
					document.body.style.position = 'fixed';
					document.body.style.width = '100%';
				} else if (isBrowser && window) {
					document.body.style.removeProperty('position');
					document.body.style.removeProperty('width');
				}
			}
		}
	};

	return [
		data,
		$userStep,
		$preselectedPlan,
		$customerType,
		steps,
		$showSuccessScreen,
		$loading,
		handleAsideClick,
		$stateLog,
		click_handler
	];
}

class RateFinder extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { data: 0 });
	}
}

export default RateFinder;